import { CurrencyFormat, formatDate } from "../../../../components/helpers";

export const convertRefundRequest = (refunds) => {
  let converted = [];

  if (!refunds) return [];

  refunds.forEach((refund, index) => {
    converted.push({
      key: index + 1,
      gadaiID: refund.gadai_id,
      dateTime: formatDate(refund.created_at) || "-",
      pawnNumber: refund.sbg_code || "-",
      gadaiCode: refund.sbg_code || "-",
      receiptNumber: refund.receipt_code || "-",
      customerName: refund.ktp_name || "-",
      remainingMoney: `Rp ${
        CurrencyFormat(refund.remainder_auction_amount) || 0
      }`,
      phone: refund.phone_1,
      nik: refund.ktp_number,
    });
  });
  return converted;
};
